import axios from 'axios'

const http = axios.create({
    baseURL: process.env.VUE_APP_URL_API,
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        "Content-type": 'Application/json',
        "Accept": "application/json"
    }
})

// Flag to prevent infinite retry loops
let isRefreshingCsrf = false
// Queue of failed requests to retry after CSRF token refresh
let failedQueue = []

const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve()
        }
    })
    failedQueue = []
}

// Response interceptor to handle CSRF token mismatch (419 error)
http.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        // Check if error is 419 (CSRF token mismatch) and request hasn't been retried yet
        if (error.response && error.response.status === 419 && !originalRequest._retry) {
            if (isRefreshingCsrf) {
                // If already refreshing, queue this request
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject })
                }).then(() => {
                    return http(originalRequest)
                }).catch(err => {
                    return Promise.reject(err)
                })
            }

            originalRequest._retry = true
            isRefreshingCsrf = true

            try {
                // Fetch fresh CSRF token
                await axios.get('/sanctum/csrf-cookie', {
                    baseURL: process.env.VUE_APP_URL_COOKIE,
                    withCredentials: true
                })

                processQueue(null)

                // Retry the original request
                return http(originalRequest)
            } catch (csrfError) {
                processQueue(csrfError)
                return Promise.reject(csrfError)
            } finally {
                isRefreshingCsrf = false
            }
        }

        return Promise.reject(error)
    }
)

export default http